import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronUpDouble = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.1666 15L9.99992 10.8333L5.83325 15M14.1666 9.16667L9.99992 5L5.83325 9.16667",
		stroke: "#0064FA",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgChevronUpDouble;
